import React, { Component } from 'react';

export default class NotAvailableAppkey extends Component {
  render() {

    return (
      <div id="kakaoContent" className="cont_bridge" role="main">
        <span className="img_404" />
        <strong className="tit_bridge">잘못된 접근입니다.</strong>
        <p className="desc_bridge">인증에 실패하여 페이지에 접근할 수 없습니다.<br />해당 기능을 제공한 서비스 관리자에게 문의해주세요.</p>
        <div className="logout_bridge">
          <a href={`${process.env.REACT_APP_KAKAO_ACCOUNT_URL}/logout?continue=${process.env.REACT_APP_SERVICE_HOST}/logged_out`}
            className="link_logout logout" data-tiara-layer="logout"
          >
            로그아웃
          </a>
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/ErrorContent/NotAvailableAppkey.js